export const environment = {
	production: false,
	DO_URL: 'https://lmc-app.tech/api',
	version: '6.29.3',
	environment: 'Production',
	iframeURL: 'https://lm.credit',
	rapidURL: 'https://lmccredit.ca/api',
	accountsEmail: 'accountsgroup@lmcredit.com',
};
